"use strict";

import { from, of, take } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
//  import { merge } from "rxjs";
import {
    mergeMap,
    catchError,
    map,
    concatMap,
    switchMap,
    exhaustMap,
    merge,
    takeUntil,
} from "rxjs/operators";

import {
    ajaxError,
    campaignGetLatestCampaignComplete,
    getHomeCarouselCampaignComplete,
    campaignHomeGetBestVoucherDealsTodayComplete,
    campaignHomeGetTrendingVouchersComplete,
    campaignGetFeaturedCampaignBannersComplete,
    campaignGetCampaignDetailsComplete,
    campaignTokenValidationComplete,
    campaignSpinwinGetDataComplete,
    campaignSpinwinGetInitialDataComplete,
    joingIncentiveDataComplete,
    campaignHomeBannersComplete,
    campaignVoucherAddToFavouriteComplete,
    campaignVoucherRemoveFromFavouriteComplete,
    refreshTokenAuthRequest,
    refreshTokenAuthComplete,
    getCampaignLeagueTableComplete,
    getParticipantSalesComplete,
    shopFavouritesRequest,
    campaignPrizeDrawDetailsComplete,
    addPrizeDrawCampaignEntryComplete,
    campaignGetCampaignDetailsRequest,
    campaignPrizeDrawDetailsRequest,
    getLeagueIndividualDetailsComplete,
    getLeagueTeamDetailsComplete,
    submitLeagueTeamParticipantComplete,
    getCommsDetailsComplete,
    campaignGetWareAndTireSummaryComplete,
    campaignGetLeagueTableSummaryComplete,
    campaignGetParticipantIncentiveComplete,
    campaignGetParticipantIncentiveCampaignPerformanceMetricsComplete,
    shopVoucherDetailsRequest,
    campaignGetCastrolLeagueTableSummaryComplete,
    campaignPageLogPageViewComplete,
    campaignLikeContentPageComplete,
    campaignLikeSummaryComplete,
    campaignLikeSummaryRequest,
    campaignGetAreaManagerDealersComplete,
    campaignGetAreaManagerDealersRequest,
    campaignGetOverdriveDealersComplete,
    campaignGetParticipantsByDealerComplete,
    campaignGetPerformanceMetricsByDealerComplete,
    campaignGetAreaManagersLeaguesRankSummaryComplete,
    campaignGetCastrolLeagueQ4TableSummaryComplete,
    campaignGetServiceManagersLeaguesBonusRankBatterySummaryComplete,
    campaignGetServiceManagersLeaguesBonusRankBrakePadsSummaryComplete,
    campaignGetServiceManagersLeaguesBonusRankWiperBladeSummaryComplete,
    campaignGetServiceManagersLeaguesBonusRankBrakeDiscsSummaryComplete,
    campaignGetServiceManagersLeaguesBonusRankAreaTopPerformerSummaryComplete,
    campaignGetLeagueNationalTopPerformerSummaryComplete,
    getTlcCustomerComplete,
    getGoldRushCampaignPerformanceSummaryComplete,
    getCastrolDealerPerformanceSummaryComplete,
    campaignGetPerformanceMetricsByDealerDropDownComplete,
    campaignGetServiceManagersLeaguesBonusRankBatterySummaryDropDownComplete,
    campaignGetLeagueNationalTopPerformerSummaryDropDownComplete,
    campaignGetLeagueTableSummaryDropDownComplete,
    campaignGetTlcRetailersComplete,
    getTlcCustomerRequest,
    campaignGetWearAndTearTeamPerformanceSummaryComplete,
    campaignGetServiceStartLeagueRankSummaryComplete,
    campaignTokenValidationError,
    campaignGetWinningSpinDataComplete,
    campaignGetLcvRegistrationTrackerComplete,
    campaignGetLcvWinningSpinsComplete,
    campaignGetLcvWinningSpinsError,
    campaignGetAlpineRewardSummaryComplete,
    campaignGetTradePartsManagerSalesSummaryComplete,
    campaignGetCastrolMotoLeaguesRankSummaryComplete,
    campaignGetTLCCustomerByDealersComplete,
    campaignGetFullThrottleLeagueRankSummaryComplete,
    campaignGoldenTicketScratchCardDataComplete,
    campaignGoldenTicketClaimScratchCardCodeComplete,
    campaignVoteRewardPreferencesComplete,
    getParticipantProfileRequest,
    campaignGetAllAreaManagerDealersComplete,
    campaignGetCastrol500CampaignDataComplete,
    campaignGetEarnBigBrakePadsCampaignDataComplete,
    campaignGetGetCuttingEdgeQ3CampaignDataComplete,
    campaignGetGetCuttingEdgeQ4CampaignDataComplete,
    campaignGetFullThrottleLeagueRankQ3SummaryComplete,
    campaignGetFullThrottleLeagueRankQ3SummaryRequest,
    campaignGetDealerEhcvFocusCampaignDataComplete,
    campaignGetServiceStar2026CampaignDataComplete,
    campaignGetIcrmCampaignDataComplete,
    campaignGetCuttingEdgeCampaignDataComplete,
    campaignSearchCustomersComplete,
    campaignGetMotrioTradeTargetsComplete,
    campaignGetCustomerAccountStatusComplete,
    campaignGetRgRewardsTargetsComplete,
    campaignGetRgRewardsTargetsByCustomerComplete,
    campaignSendActivationEmailComplete,
    campaignGetCustomerAccountStatusRequest,
    campaignGetMotrioRewardsByCustomerComplete,
    campaignGetMotrioPaydaysWinnersComplete,
    campaignGetCastrolLegendsCampaignDataComplete,
    campaignGetCastrolLegendsCampaignPerformanceDataComplete,
    campaignGetLiquidGoldCampaignInfoComplete,
    campaignValidateLiquidGoldScratchCodeComplete,
    campaignValidateLiquidGoldScratchCodeError,
    campaignClaimLiquidGoldScratchCodeComplete,
    campaignGetOptimumFrictionCampaignInfoComplete,
    campaignGetOptimumFrictionCardsComplete,
    campaignGetOptimumFrictionWinnersComplete,
    campaignPlayOptimumFrictionCardComplete,
    campaignPlayOptimumFrictionCardError,
    campaignGetOverDriveCampaignDataComplete,
} from "../_actions";
import {
    campaignConstants,
    requestTypes,
    authConstants,
    commonConstants,
    addRemoveFavouriteContent,
    participantJobRoleIds,
} from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";

export const getLatestCampaignEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_LATEST_CAMPAIGN_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/latest-campaigns",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetLatestCampaignComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getHomeCarouselCampaignEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_HOME_CAROUSEL_CAMPAIGN_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/carousel-campaigns",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getHomeCarouselCampaignComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getHomeGetBestVoucherDealsTodayEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_HOME_BEST_VOUCHER_DEALS_TODAY_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/shop/spend-on-experiences",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignHomeGetBestVoucherDealsTodayComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error, source) => {
                        if (error.response.statusCode == "401") {
                            return actions$.pipe(
                                ofType(
                                    authConstants.AUTH_GET_REFRESH_TOKEN_COMPLETE,
                                ),
                                take(1),
                                mergeMap((action) => source),
                                merge(of(refreshTokenAuthRequest())),
                                takeUntil(
                                    actions$.pipe(
                                        ofType(
                                            commonConstants.REFRESH_TOKEN_ERROR,
                                        ),
                                    ),
                                ),
                            );
                        } else {
                            return of(ajaxError(error));
                        }
                    }),
                ),
        ),
    );
};

export const getHomeGetTrendingVouchersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_HOME_TRENDING_VOUCHER_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/campaign-vouchers",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignHomeGetTrendingVouchersComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getFeaturedCampaignBannersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_FEATURED_CAMPAIGN_BANNERS_REQUEST),
        mergeMap((action) =>
            ajax
                .get(
                    "/api/campaign/featured-banners",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetFeaturedCampaignBannersComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getHomeGetCampaignDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_CAMPAIGN_DETAILS_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/campaign-details",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetCampaignDetailsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const campaignTokenValidationEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_SPINWIN_TOKEN_VALIDATION_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/validate-spinwin-tokens",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignTokenValidationComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) =>
                        of(ajaxError(error)).pipe(
                            concatMap(() => of(campaignTokenValidationError())),
                        ),
                    ),
                ),
        ),
    );
};

export const campaignValidateLiquidGoldScratchCodeEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_LIQUID_GOLD_SCRATCH_CODE_VALIDATION_REQUEST,
        ),
        mergeMap((action) => {
            const isCampaign379 = action.payload.campaignId === 379 || action.payload.campaignId === 407;
            const endpoint = isCampaign379
                ? "/api/campaign/validate-liquid-gold-scratch-code"
                : "/api/home/validate-liquid-gold-scratch-code";
            const payload = { ...action.payload, campaignId: 407 };
            return ajax
                .post(
                    endpoint,
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) =>
                        campaignValidateLiquidGoldScratchCodeComplete({
                            response: ajaxResponse.response,
                            code: action.payload.code,
                        }),
                    ),
                    catchError((error) =>
                        of(ajaxError(error)).pipe(
                            concatMap(() =>
                                of(campaignValidateLiquidGoldScratchCodeError()),
                            ),
                        ),
                    ),
                );
        }),
    );
};

export const campaignSpinwingetDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_SPINWIN_GET_DATA_REQUEST),
        mergeMap((action) => {
            const { setSuccessView, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/campaign/get-hitandwin-spin-data",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        setSuccessView(ajaxResponse.response.data);
                        return campaignSpinwinGetDataComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignSpinwingetInitialDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_SPINWIN_GET_INITIAL_DATA_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/get-hitandwin-spin-initial-data",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignSpinwinGetInitialDataComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const joinIncentiveDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.JOING_INCENTIVE_DATA_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/join-incentive",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return joingIncentiveDataComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getCampaignHomeBannersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_HOME_BANNERS_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    "/api/campaign/home-banners",
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignHomeBannersComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getCampaignVoucherAddToFavouriteEpic = (
    actions$,
    state$,
    { dispatch },
) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_VOUCHER_ADDTO_FAVOURITE_REQUEST),
        mergeMap((action) => {
            const { from, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/campaign/campaign-voucher-addto-favourite",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        if (
                            addRemoveFavouriteContent.FROM_PRODUCT_CONTENT ==
                            from
                        ) {
                            dispatch(
                                shopVoucherDetailsRequest({ id: payload.id }),
                            );
                        }

                        if (addRemoveFavouriteContent.FROM_WALLET == from) {
                        }

                        if (addRemoveFavouriteContent.FROM_HOME_PAGE == from) {
                            dispatch(
                                shopFavouritesRequest({
                                    pageNumber: 1,
                                    pageSize: 8,
                                    type: 0,
                                }),
                            );
                        }

                        return campaignVoucherAddToFavouriteComplete(
                            action.payload,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getCampaignVoucherRemoveFromFavouriteEpic = (
    actions$,
    state$,
    { dispatch },
) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_VOUCHER_REMOVEFROM_FAVOURITE_REQUEST),
        mergeMap((action) => {
            const { from, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/campaign/campaign-voucher-removefrom-favourite",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        if (
                            addRemoveFavouriteContent.FROM_PRODUCT_CONTENT ==
                            from
                        ) {
                            dispatch(
                                shopVoucherDetailsRequest({ id: payload.id }),
                            );
                        }

                        if (addRemoveFavouriteContent.FROM_WALLET == from) {
                        }

                        if (addRemoveFavouriteContent.FROM_HOME_PAGE == from) {
                            dispatch(
                                shopFavouritesRequest({
                                    pageNumber: 1,
                                    pageSize: 8,
                                    type: 0,
                                }),
                            );
                        }

                        return campaignVoucherRemoveFromFavouriteComplete(
                            action.payload,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getCampaignLeagueTableEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_CAMPAIGN_LEAGUE_TABLE_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-league-table",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getCampaignLeagueTableComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getParticipantSalesEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_PARTICIPANT_SALES_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/user/get-participant-sales",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getParticipantSalesComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignPrizeDrawDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_CAMPAIGN_PRIZEDRAW_DETAILS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-prizedraw-details",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignPrizeDrawDetailsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const addPrizeDrawCampaignEntryDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.ADD_PRIZE_DRAW_CAMPAIGN_ENTRY_DATA_REQUEST),
        mergeMap((action) => {
            const { tokenForms, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/campaign/add-prize-draw-campaign-entry",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        tokenForms.forEach((form) => {
                            form.reset();
                        });

                        return of(
                            campaignGetCampaignDetailsRequest({
                                id: action.payload.campaignId,
                            }),

                            campaignPrizeDrawDetailsRequest({
                                id: action.payload.campaignId,
                            }),

                            addPrizeDrawCampaignEntryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getLeagueIndividualDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_LEAGUE_INDIVIDUAL_DETAILS_DATA_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/league-individual-details",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getLeagueIndividualDetailsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getLeagueTeamDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_LEAGUE_TEAM_DETAILS_DATA_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/league-team-details",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getLeagueTeamDetailsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const submitLeagueTeamParticipantEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.SUBMIT_LEAGUE_TEAM_PARTICIPANT_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/submit-league-team-participant",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return submitLeagueTeamParticipantComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getCommsDetailsEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_COMMS_DETAILS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/comms-details",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getCommsDetailsComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetWareAndTireSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_WARE_AND_TIRE_SUMMARY_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-ware-and-tire-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetWareAndTireSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetLeagueTableSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-league-table-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetLeagueTableSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetLeagueTableSummaryDropDownEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_LEAGUE_TABLE_SUMMARY_DROP_DOWN_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-league-table-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetLeagueTableSummaryDropDownComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetParticipantIncentiveEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_PARTICIPANT_ACTIVE_CAMPAIGNS_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-participant-incentive",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetParticipantIncentiveComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetParticipantIncentiveCampaignPerformanceMetricsEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_PARTICIPANT_INCENTIVE_PERFORMANCE_METRICS_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-participant-incentive-campaign-performance-metrics",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetParticipantIncentiveCampaignPerformanceMetricsComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetCastrolLeagueTableSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-castrol-league-table-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetCastrolLeagueTableSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetCastrolLeagueQ4TableSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_CASTROL_LEAGUE_TABLE_Q4_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-castrol-league-q4-table-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetCastrolLeagueQ4TableSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignPageLogPageViewEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_PAGE_LOG_PAGE_VIEW_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-page-log-page-view",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignPageLogPageViewComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignLikeContentPageEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_PAGE_LIKE_CONTENT_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-page-like-content",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignLikeContentPageComplete(
                                ajaxResponse.response,
                            ),
                            campaignLikeSummaryRequest(action.payload),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignLikeSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_PAGE_LIKE_SUMMARY_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-page-summary-like-content",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignLikeSummaryComplete(ajaxResponse.response),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetAreaManagerDealersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_AREA_MANAGERS_DEALERS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-area-manager-dealers",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetAreaManagerDealersComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetOverdriveDealersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_OVERDRIVE_DEALERS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-area-manager-dealers",
                    { ...action.payload, remanOverdriveTargetedOnly: true },
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetOverdriveDealersComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetParticipantsByDealerEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_PARTICIPANTS_BY_DEALERS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-participants-by-dealer",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetParticipantsByDealerComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetPerformanceMetricsByDealerEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-performance-metrics-by-dealer",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetPerformanceMetricsByDealerComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetPerformanceMetricsByDealerDropDownEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_PERFORMANCE_METRICS_BY_DEALERS_DROP_DOWN_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-performance-metrics-by-dealer",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetPerformanceMetricsByDealerDropDownComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetAreaManagersLeaguesRankSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-area-managers-leagues-rank-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetAreaManagersLeaguesRankSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetServiceManagersLeaguesBonusBatteryRankSummaryEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-service-managers-leagues-battery-rank-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetServiceManagersLeaguesBonusRankBatterySummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetServiceManagersLeaguesBonusBatteryRankSummaryDropDownEpic =
    (actions$) => {
        return actions$.pipe(
            ofType(
                campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BATTERY_SUMMARY_DROP_DOWN_REQUEST,
            ),
            mergeMap((action) => {
                return ajax
                    .post(
                        "/api/campaign/campaign-get-service-managers-leagues-battery-rank-summary",
                        action.payload,
                        getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                        concatMap((ajaxResponse) => {
                            return of(
                                campaignGetServiceManagersLeaguesBonusRankBatterySummaryDropDownComplete(
                                    ajaxResponse.response,
                                ),
                            );
                        }),
                        catchError((error) => of(ajaxError(error))),
                    );
            }),
        );
    };

export const campaignGetServiceManagersLeaguesBonusBrakePadsRankSummaryEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_PADS_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-service-managers-leagues-bonus-rank-brake-pads-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetServiceManagersLeaguesBonusRankBrakePadsSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetServiceManagersLeaguesBonusRankWiperBladeSummaryEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_WIPER_BLADE_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-service-managers-leagues-bonus-rank-wiper-blade-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetServiceManagersLeaguesBonusRankWiperBladeSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetServiceManagersLeaguesBonusRankBrakeDiscsSummaryEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_BRAKE_DISCS_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-service-managers-leagues-bonus-rank-brake-discs-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetServiceManagersLeaguesBonusRankBrakeDiscsSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetServiceManagersLeaguesBonusRankAreaTopPerformerSummaryEpic =
    (actions$) => {
        return actions$.pipe(
            ofType(
                campaignConstants.CAMPAIGN_GET_SERVICE_MANAGER_LEAGUES_BONUS_RANK_AREA_TOP_SUMMARY_REQUEST,
            ),
            mergeMap((action) => {
                return ajax
                    .post(
                        "/api/campaign/campaign-get-service-managers-leagues-bonus-rank-area-top-summary",
                        action.payload,
                        getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                        concatMap((ajaxResponse) => {
                            return of(
                                campaignGetServiceManagersLeaguesBonusRankAreaTopPerformerSummaryComplete(
                                    ajaxResponse.response,
                                ),
                            );
                        }),
                        catchError((error) => of(ajaxError(error))),
                    );
            }),
        );
    };

export const campaignGetLeagueNationalTopPerformerSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-league-national-top-performer-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetLeagueNationalTopPerformerSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetLeagueNationalTopPerformerSummaryDropDownEpic = (
    actions$,
) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_LEAGUE_NATIONAL_TOP_PERFORMER_SUMMARY_DROP_DOWN_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-league-national-top-performer-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetLeagueNationalTopPerformerSummaryDropDownComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const getTlcCustomerEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.GET_TLC_CUSTOMER_REQUEST),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/get-tlc-customers",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getTlcCustomerComplete(ajaxResponse.response);
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getGoldRushCampaignPerformanceSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.GET_GOLD_RUSH_CAMPAIGN_PERFORMANCE_SUMMARY_REQUEST,
        ),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/get-gold-rush-campaign-performance-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getGoldRushCampaignPerformanceSummaryComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const getCastrolDealerPerformanceSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.GET_CASTROL_DEALER_PERFORMANCE_SUMMARY_REQUEST,
        ),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/get-castrol-dealer-performance-summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return getCastrolDealerPerformanceSummaryComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const campaignGetTlcRetailersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.TLC_GET_TLC_RETAILERS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/get-tlc-retailer",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        if (
                            action?.payload ===
                            participantJobRoleIds.TLC_PARTICIPANT_AREA_MANAGER
                        ) {
                            return of(
                                getTlcCustomerRequest({
                                    reatilerId:
                                        ajaxResponse.response.data[0]?.id,
                                    reatilerName:
                                        ajaxResponse.response.data[0]?.name,
                                }),
                                campaignGetTlcRetailersComplete(
                                    ajaxResponse.response,
                                ),
                            );
                        } else {
                            return of(
                                campaignGetTlcRetailersComplete(
                                    ajaxResponse.response,
                                ),
                            );
                        }
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetWearAndTearTeamPerformanceSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_WEAR_AND_TEAR_TEAM_PERFORMANCE_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetWearAndTearTeamPerformanceSummary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetWearAndTearTeamPerformanceSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetServiceStartLeagueRankSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_SERVICE_STAR_GET_SERVICE_STAR_LEAGUE_RANK_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetServiceStartLeagueRankSummary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetServiceStartLeagueRankSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetWinningSpinDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_WINNING_SPIN_DATA_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetWinningSpinsData",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetWinningSpinDataComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

// The month's played LCV codes for one campaign. A failure is kept on the slice so the card can
// show the backend message in place of the list.
export const campaignGetLcvWinningSpinsEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_LCV_WINNING_SPINS_REQUEST),
        mergeMap((action) => {
            const { year, month, campaignId } = action.payload ?? {};
            const campaignQuery = campaignId
                ? `&campaignId=${encodeURIComponent(campaignId)}`
                : "";

            return ajax
                .get(
                    `/api/campaign/lcv-winning-spins?year=${encodeURIComponent(
                        year,
                    )}&month=${encodeURIComponent(month)}${campaignQuery}`,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) =>
                        campaignGetLcvWinningSpinsComplete(ajaxResponse.response),
                    ),
                    catchError((error) =>
                        of(
                            campaignGetLcvWinningSpinsError(
                                error?.response?.message ??
                                    "We could not load your winning spins. Please try again.",
                            ),
                        ),
                    ),
                );
        }),
    );
};

export const campaignGetLcvRegistrationTrackerEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_LCV_REGISTRATION_TRACKER_REQUEST,
        ),
        mergeMap((action) => {
            const year = action.payload?.year;
            const month = action.payload?.month;
            const dealershipId = action.payload?.dealershipId;
            const campaignId = action.payload?.campaignId;
            const campaignQuery = campaignId
                ? `&campaignId=${encodeURIComponent(campaignId)}`
                : "";

            return ajax
                .get(
                    `/api/campaign/lcv-registration-tracker?year=${encodeURIComponent(
                        year,
                    )}&month=${encodeURIComponent(month)}&dealershipId=${encodeURIComponent(dealershipId)}${campaignQuery}`,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetLcvRegistrationTrackerComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetAlpineRewardSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_ALPINE_REWARD_SUMMARY_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetAlpineRewardSummary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetAlpineRewardSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetTradePartsManagerSalesSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_TRADE_PARTS_MANAGER_INCENTIVE_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetTradePartsManagerSalesSummary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetTradePartsManagerSalesSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetCastrolMotoLeaguesRankSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_CASTROL_MOTO_GP_LEAGUES_RANK_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetCastrolMotoLeaguesRankSummary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetCastrolMotoLeaguesRankSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetTLCCustomerByDealersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_TLC_CUSTOMER_BY_DEALERS_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/getTLCCustomerByDealers",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetTLCCustomerByDealersComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetFullThrottleLeagueRankSummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/getFullThrottleLeagueRankSummary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetFullThrottleLeagueRankSummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGoldenTicketScratchCardDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GOLDEN_TICKET_SCRATCH_CARD_DATA_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/goldenTicketScratchCardData",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGoldenTicketScratchCardDataComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGoldenTicketClaimScratchCardCodeEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GOLDEN_TICKET_CLAIM_SCRATCH_CARD_CODE_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/claimScratchCardCode",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGoldenTicketClaimScratchCardCodeComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignVoteRewardPreferencesEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_VOTE_REWARD_PREFERENCES_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/VoteRewardPreferences",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            getParticipantProfileRequest({}),
                            campaignVoteRewardPreferencesComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};
export const campaignGetAllAreaManagerDealersEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_ALL_AREA_MANAGERS_DEALERS_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/campaign-get-area-manager-dealers",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetAllAreaManagerDealersComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetCastrol500CampaignDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_CASTROL500_CAMPAIGN_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetCastrol500CampaignData",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetCastrol500CampaignDataComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetEarnBigBrakeCampaignDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_EARN_BIG_BRAKE_CAMPAIGN_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetEarnBigBrakePadsCampaignData",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetEarnBigBrakePadsCampaignDataComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetCuttingEdgeQ3CampaignDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_CUTTING_EDGE_Q3_CAMPAIGN_DATA_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetCuttingEdgeQ3CampaignData",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetGetCuttingEdgeQ3CampaignDataComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetCuttingEdgeQ4CampaignDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_CUTTING_EDGE_Q4_CAMPAIGN_DATA_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetCuttingEdgeQ4CampaignData",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetGetCuttingEdgeQ4CampaignDataComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetFullThrottleLeagueRankQ3SummaryEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_FULL_THROTTLE_LEAGUE_RANK_Q3_SUMMARY_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetFullThrottleLeagueRankQ3Summary",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetFullThrottleLeagueRankQ3SummaryComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetDealerEhcvFocusCampaignDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_DEALER_EHCV_FOCUS_CAMPAIGN_DATA_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetDealerEhcvFocusCampaignData",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetDealerEhcvFocusCampaignDataComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) =>
                        of(
                            campaignGetDealerEhcvFocusCampaignDataComplete({
                                data: {},
                            }),
                            ajaxError(error),
                        ),
                    ),
                );
        }),
    );
};

export const campaignGetServiceStar2026CampaignDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_SERVICE_STAR_2026_CAMPAIGN_DATA_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetServiceStar2026CampaignData",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetServiceStar2026CampaignDataComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetIcrmCampaignDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_ICRM_CAMPAIGN_DATA_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetIcrmCampaignData",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetIcrmCampaignDataComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) =>
                        of(
                            campaignGetIcrmCampaignDataComplete({
                                data: {},
                            }),
                            ajaxError(error),
                        ),
                    ),
                );
        }),
    );
};

export const campaignGetCuttingEdgeCampaignDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_CUTTING_EDGE_CAMPAIGN_DATA_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetCuttingEdgeCampaignData",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetCuttingEdgeCampaignDataComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignSearchCustomersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_SEARCH_CUSTOMERS_REQUEST),
        mergeMap((action) => {
            let url = `/api/campaign/search-customers/${action.payload.searchTerm}`;
            
            // Add query parameter if isMotorCustomer is true
            if (action.payload.isMotorCustomer === true) {
                url += "?isMotorCustomer=true";
            }
            
            return ajax
                .get(
                    url,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignSearchCustomersComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetMotrioTradeTargetsEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_MOTRIO_TRADE_TARGETS_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    `/api/campaign/get-motrio-trade-targets/${action.payload.customerId}/${action.payload.month}`,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetMotrioTradeTargetsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetCustomerAccountStatusEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_CUSTOMER_ACCOUNT_STATUS_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    `/api/campaign/get-customer-account-status/${action.payload.customerId}`,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetCustomerAccountStatusComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetRgRewardsTargetsEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_RG_REWARDS_TARGETS_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    `/api/campaign/get-rg-rewards-targets/${action.payload.customerId}/${action.payload.month}`,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetRgRewardsTargetsComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetRgRewardsTargetsByCustomerEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_RG_REWARDS_TARGETS_BY_CUSTOMER_REQUEST,
        ),
        mergeMap((action) => {
            return ajax
                .get(
                    `/api/campaign/get-rg-rewards-targets-by-customer/${action.payload.customerId}/${action.payload.month}`,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetRgRewardsTargetsByCustomerComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignSendActivationEmailEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_SEND_ACTIVATION_EMAIL_REQUEST),
        mergeMap((action) => {
            const { customerId, ...payload } = action.payload;

            return ajax
                .post(
                    "/api/campaign/send-activation-email",
                    payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    concatMap((ajaxResponse) => {
                        return of(
                            campaignGetCustomerAccountStatusRequest({
                                customerId: customerId,
                            }),
                            campaignSendActivationEmailComplete(
                                ajaxResponse.response,
                            ),
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetMotrioRewardsByCustomerEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_MOTRIO_REWARDS_BY_CUSTOMER_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    `/api/campaign/v1/ParticipantIncentiveCampaign/GetMotrioRewardsByCustomer/${action.payload.customerId}/${action.payload.month}`,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetMotrioRewardsByCustomerComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetMotrioPaydaysWinnersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_MOTRIO_PAYDAYS_WINNERS_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    action.payload.dealerCode
                        ? `/api/campaign/GetMotrioPaydaysWinners/${action.payload.month}?dealerCode=${encodeURIComponent(action.payload.dealerCode)}`
                        : `/api/campaign/GetMotrioPaydaysWinners/${action.payload.month}`,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetMotrioPaydaysWinnersComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetCastrolLegendsCampaignDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_CASTROL_LEGENDS_CAMPAIGN_DATA_REQUEST),
        mergeMap(() => {
            return ajax
                .get(
                    "/api/campaign/GetCastrolLegendsCampaignData",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetCastrolLegendsCampaignDataComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetCastrolLegendsCampaignPerformanceDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_CASTROL_LEGENDS_CAMPAIGN_PERFORMANCE_DATA_REQUEST),
        mergeMap((action) => {
            return ajax
                .get(
                    `/api/campaign/GetCastrolLegendsCampaignPerformanceData/${action.payload.dealerCode}`,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetCastrolLegendsCampaignPerformanceDataComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetLiquidGoldCampaignInfoEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_LIQUID_GOLD_CAMPAIGN_INFO_REQUEST,
        ),
        mergeMap(() =>
            ajax
                .get(
                    "/api/home/get-liquid-gold-campaign-info",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetLiquidGoldCampaignInfoComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const campaignClaimLiquidGoldScratchCodeEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_CLAIM_LIQUID_GOLD_SCRATCH_CODE_REQUEST,
        ),
        mergeMap((action) =>
            ajax
                .post(
                    "/api/campaign/claimLiquidGoldScratchCode",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) =>
                        campaignClaimLiquidGoldScratchCodeComplete(
                            ajaxResponse.response,
                        ),
                    ),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const campaignGetOverDriveCampaignDataEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_OVER_DRIVEN_CAMPAIGN_DATA_REQUEST),
        mergeMap((action) => {
            return ajax
                .post(
                    "/api/campaign/GetOverDriveCampaignData",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) => {
                        return campaignGetOverDriveCampaignDataComplete(
                            ajaxResponse.response,
                        );
                    }),
                    catchError((error) => of(ajaxError(error))),
                );
        }),
    );
};

export const campaignGetOptimumFrictionCampaignInfoEpic = (actions$) => {
    return actions$.pipe(
        ofType(
            campaignConstants.CAMPAIGN_GET_OPTIMUM_FRICTION_CAMPAIGN_INFO_REQUEST,
        ),
        mergeMap(() =>
            ajax
                .get(
                    "/api/campaign/optimum-friction-campaign-info",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) =>
                        campaignGetOptimumFrictionCampaignInfoComplete(
                            ajaxResponse.response,
                        ),
                    ),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

// The month filter is part of the address rather than a body, so a fresh month replaces the
// one in flight with switchMap instead of racing it.
export const campaignGetOptimumFrictionCardsEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_OPTIMUM_FRICTION_CARDS_REQUEST),
        switchMap((action) =>
            ajax
                .get(
                    `/api/campaign/optimum-friction-cards?year=${action.payload?.year ?? ""}&month=${action.payload?.month ?? ""}`,
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) =>
                        campaignGetOptimumFrictionCardsComplete(
                            ajaxResponse.response,
                        ),
                    ),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

export const campaignGetOptimumFrictionWinnersEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_GET_OPTIMUM_FRICTION_WINNERS_REQUEST),
        mergeMap(() =>
            ajax
                .get(
                    "/api/campaign/optimum-friction-winners",
                    getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                )
                .pipe(
                    map((ajaxResponse) =>
                        campaignGetOptimumFrictionWinnersComplete(
                            ajaxResponse.response,
                        ),
                    ),
                    catchError((error) => of(ajaxError(error))),
                ),
        ),
    );
};

// A play takes the card and cannot be repeated, so a second press while the first is still
// running is ignored rather than queued behind it.
export const campaignPlayOptimumFrictionCardEpic = (actions$) => {
    return actions$.pipe(
        ofType(campaignConstants.CAMPAIGN_PLAY_OPTIMUM_FRICTION_CARD_REQUEST),
        exhaustMap((action) =>
            ajax
                .post(
                    "/api/campaign/playOptimumFrictionCard",
                    action.payload,
                    getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                )
                .pipe(
                    map((ajaxResponse) =>
                        campaignPlayOptimumFrictionCardComplete(
                            ajaxResponse.response,
                        ),
                    ),
                    // The message the advisor reads belongs to the response, so the error is
                    // kept on the campaign slice as well as raised globally.
                    catchError((error) =>
                        of(
                            campaignPlayOptimumFrictionCardError(
                                error?.response ?? error,
                            ),
                            ajaxError(error),
                        ),
                    ),
                ),
        ),
    );
};
